module.exports = __webpack_public_path__ + "img/resource-no.7a95a390.png";